module.exports = __webpack_public_path__ + "img/thumbnail_RedNeckedWallaby_f_albino.f4b52141.png";